import styled from 'styled-components';

import { SectionRenderer } from '../components/blocks/SectionRenderer';
import { TierCard } from '../components/blocks/TierCard';
import { Container } from '../components/primitives/Container';
import { SectionHead } from '../components/primitives/SectionHead';
import { useContent } from '../content/load';
import { useDocumentTitle } from '../lib/seo';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: ${(p) => p.theme.step[5]}px;
  padding-bottom: ${(p) => p.theme.step[8]}px;
`;

export default function Pricing() {
  const { tiers, pages } = useContent();
  const page = pages.pricing;
  useDocumentTitle(page?.seo.title, page?.seo.description);
  return (
    <Container>
      {page ? (
        page.sections.map((s, i) => <SectionRenderer key={i} section={s} />)
      ) : (
        <SectionHead
          eyebrow="PRICING"
          heading="Capital under your terms."
          body="Three tiers, no lock-in, transparent fees."
        />
      )}
      <Grid>
        {tiers.map((t) => (
          <TierCard key={t.id} tier={t} />
        ))}
      </Grid>
    </Container>
  );
}
